module.exports = __webpack_public_path__ + "img/service-8-2.91982b62.jpeg";